import { CSSObject } from "@emotion/react";
import { type CheckboxStyleOverrides } from "@newsela/angelou";

export const readingSkillCheckboxCss: CheckboxStyleOverrides<CSSObject> = {
  root: {
    padding: "4px",
  },

  labelText: {
    display: "flex",
    flexDirection: "row-reverse",
    marginLeft: "-5px",

    svg: {
      width: "24px",
      marginRight: "4px",
    },
  },
};
